import React, { memo } from 'react';

import { EnhancedReturnDetails } from '../enhanced-return/enhanced-return-details';
import ErrorBoundary from '../../../components/error-boundary';
import { newReturnSteps } from '../enhanced-return/steps/steps';
import { StepDetectiveProvider } from '../../../components/csv-import/ui/components/step-detective/step-detective-context';

const EnhancedReturnLoader = ({ returnFulfillmentId }) => {
  return (
    <ErrorBoundary errorMessageId='app'>
      <StepDetectiveProvider originalSteps={newReturnSteps}>
        <EnhancedReturnDetails returnFulfillmentId={returnFulfillmentId} />
      </StepDetectiveProvider>
    </ErrorBoundary>
  );
};

export default memo(EnhancedReturnLoader);
